export default __webpack_public_path__ + "static/media/kitchen2-768w.eb89d34e.webp";